<template>
  <div>
    <mb-header title="等待考试" :back="goBack"/>
    <div class="mb-container">
      <template v-if="noTest">
        <img class="empty" src="~images/pretest/empty.png">
        <div>
          <p>选手你好，并未检测到此账号的参赛资格，请确认：</p>
          <p>（1）如果你报名的是Kitten或Python赛项，请使用报名账号在电脑端登录比赛官网参加比赛；</p>
          <p>（2）如果你报名的是Nemo赛项且确认有参赛资格，请尝试找回账号或联系赛事指导老师，添加时请备注：比赛名称+地区+你的身份（家长/老师）</p>
        </div>
        <img class="qrcode" src="~images/pretest/qrcode.png" alt="">
      </template>
    </div>
  </div>
</template>
<script>
import MbHeader from '@/components/MbHeader'
import { post } from '@/utils/ajax'
import { mapState } from 'vuex'
import { Loading } from 'element-ui'
import {
  CLOSE_WEBVIEW,
  postMessageSyn
} from '@/utils/dsbridge'
export default {
  components: {
    MbHeader
  },
  data() {
    return {
      noTest: false
    }
  },
  computed: {
    ...mapState(['user', 'theme'])
  },
  mounted() {
    this.getExams()
  },
  methods: {
    async getExams () {
      const body = {
        limit: 1,
        page: 1
      }
      const loading = Loading.service({ fullscreen: true })
      try {
        let items = []
        const link = `/home/edu/examinees/${this.user.id}/exams?tab=tabStatus&exam_type=2&site_id=${this.theme.id}`
        const res = await post(link.replace('tabStatus', 1), body)
        items = res.items
        if (!items.length) {
          const completeRes = await post(link.replace('tabStatus', 2), body)
          items = completeRes.items
          if (!items.length) {
            this.noTest = true
            return
          }
        }
        localStorage.setItem('examId', items[0].exam_id)
        this.$router.replace({ name: 'pretest' })
      } catch (error) {
        console.log(error)
      } finally {
        loading.close()
      }
    },
    goBack() {
      postMessageSyn(CLOSE_WEBVIEW)
    }
  }
}
</script>
<style lang="scss" scoped>
.mb-container{
  position: absolute;
  left: 0;
  top: 88px;
  width: 100%;
  height: calc(100vh - 88px);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 40px;
  .empty{
    width: 455px;
    height: 240px;
    margin-bottom: 40px;
  }
  p{
    font-size: 28px;
    font-weight: 400;
    color: #999999;
    line-height: 45px;
    letter-spacing: 2px;
  }
  .qrcode{
    width: 200px;
    height: 200px;
    margin-top: 40px;
  }
}
</style>
